import { DocPage } from "../components/DocPage";

export const ssr = { mode: "ssg" as const };

export default function Ssr() {
  return (
    <DocPage
      title="SSR — Landrr.js"
      description="How server-side rendering works in Landrr.js."
    >
      <h1>Server-side rendering</h1>
      <p>
        In dev and on Node hosts, Landrr renders HTML on each request using your
        <code> entry-server.tsx</code> and page modules.
      </p>
      <pre>
        <code>{`export async function getServerData() {
  return { renderedAt: new Date().toISOString() };
}

export default function Page({ serverData }) {
  return <h1>Hello</h1>;
}`}</code>
      </pre>
      <p>
        Use <code>getServerData</code> for data that should be available on the
        server and passed to the client via <code>window.__LANDRR_DATA__</code>.
      </p>
    </DocPage>
  );
}
